import useLanguage from "../../i18n/useLanguage";

export default function AiPhotoExample({ example }) {
  const { t } = useLanguage();
  return (
    <a href={example.src} target="_blank" rel="noopener noreferrer" aria-label={`${t("Lihat foto")}: ${t(example.alt)}`} className="block overflow-hidden rounded-xl border border-white/10 hover:border-amber-300/60 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-amber-300">
      <img src={example.src} alt={t(example.alt)} width="900" height="1600" loading="lazy" decoding="async" className="aspect-[9/16] w-full object-cover" />
    </a>
  );
}
